import axios from 'axios';
import Vue from 'vue'
import router from '../router'
import errorService from './errorService'

function goToLogin () {
  router.replace({ path: '/login' })
}

const HTTP = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    'Content-Type': 'application/vnd.api+json'
  }
})

//Request interceptor para incluir el token
HTTP.interceptors.request.use((config) => {
  return Vue.localForage.$getItem('token')
  .then((token) => {
    config.headers[process.env.VUE_APP_TOKEN_HEADER] = token
    return config
  })
  .catch((err) => {
    return Promise.reject(err)
  })
}, (error) => {
  return Promise.reject(error)
})

//Response interceptor para detectar error 403
HTTP.interceptors.response.use( (response) => {
  return Promise.resolve(response.data)
}, (error) => {
  // && error.response.data.error.msg === 'Token no válido'
  if (error.response && error.response.status === 403) {
    Vue.localForage.$clearStorage
    goToLogin()
  }
  errorService.add(error)
  return Promise.reject(null)
})

export { HTTP }



// WEBPACK FOOTER //
// ./src/services/http-common.js